import {
  ApiService,
  ParentModel,
  requestHelper,
  type AuthService,
  type PageModel,
  type ServiceStore,
} from '@blueprint/frontend-basics'

import { PlatformUserStatsDto } from '@/models/dtos/admin.dto.ts'
import { ShopDto } from '@/models/dtos/shop.dto.ts'

export class AdminService extends ApiService {
  private readonly backendURL: string

  constructor(
    serviceStore: ServiceStore,
    authService: AuthService,
    backendURL: string,
  ) {
    super(serviceStore, authService)
    this.backendURL = backendURL
  }

  public async getPlatformUserStats(): Promise<PlatformUserStatsDto> {
    const headers = await this.getAuthHeaders()
    const response = await requestHelper.get(
      `${this.backendURL}/admin/platform-user-stats`,
      { headers },
    )
    return ParentModel.fromJson(response.data, PlatformUserStatsDto)
  }

  public async listShops(
    page: number = 0,
    pageSize: number = 20,
  ): Promise<PageModel<ShopDto>> {
    const headers = await this.getAuthHeaders()
    const response = await requestHelper.get(`${this.backendURL}/admin/shops`, {
      headers,
      params: { page, pageSize },
    })
    return ParentModel.fromPaginatedJson(response.data, ShopDto)
  }
}
